import styled from 'styled-components';
import { Link, Text } from '@amzn/storm-ui';

export const UploadContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DownloadContainer = styled.div`
  margin-left: 5rem;
`;

export const ExcelIcon = styled.img`
  width: 3.25rem;
  height: 3.25rem;
`;

export const DownloadLink = styled(Link)`
  display: flex;
  flex-direction: column;
  text-decoration: underline;
  color: ${({ theme }) => theme.color.blue[700]};
  font-size: 0.8rem;
  :hover {
    color: ${({ theme }) => theme.color.gray[600]};
  }
`;

export const ErrorText = styled(Text)`
  color: ${({ theme }) => theme.color.red[700]};
  white-space: pre-line;
`;

export const FileNameText = styled(Text)`
  color: ${({ theme }) => theme.color.green[700]};
`;

export const DropdownContainer = styled.div`
  margin-top: 1rem;
  width: max-content;
  margin-bottom: 1rem;
`;

export const CustomAlertErrorWrapper = styled.div`
  white-space: pre-line;
`;
